import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ExchangeGeneralContent } from '@ui/src';
import { useAppSelector } from '@store';

import useProblemExchangeTransaction from '../hooks/use-exchange';

const ProblemExchangeGeneralContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const { transaction } = useAppSelector(
    (state) => state.customersProblemTransactions.exchange,
  );
  const { overdraftEnabled } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { currencies: currenciesList } = useAppSelector((state) => state.root);

  const {
    getExchangeStatementAction,
    getFromAccountBalanceAction,
    getToAccountBalanceAction,
    fromAccountBalance,
    toAccountBalance,
    statementsIsLoading,
    fromAccountBalances,
    toAccountBalances,
  } = useProblemExchangeTransaction({
    transaction,
    transactionId,
  });

  useEffect(() => {
    if (!transaction && transactionId) {
      getExchangeStatementAction();
    }
  }, [getExchangeStatementAction, transaction, transactionId]);

  useEffect(() => {
    if (transaction) {
      getFromAccountBalanceAction();
      getToAccountBalanceAction();
    }
  }, [transaction]);

  return (
    <ExchangeGeneralContent
      transactionInfo={transaction}
      fromAccountBalance={fromAccountBalance}
      toAccountBalance={toAccountBalance}
      currencyFromName={transaction?.exchangeCurrencyFrom?.name}
      currencyToName={transaction?.exchangeCurrencyTo?.name}
      senderAccountName={transaction?.senderAccount?.fullNumber}
      recipientAccountName={transaction?.recipientAccount?.fullNumber}
      rateSourceName={transaction?.exchangeRateSource?.name}
      isLoading={statementsIsLoading}
      exchangeType={transaction?.exchangeType}
      currenciesList={currenciesList}
      overdraftEnabled={overdraftEnabled}
      senderAccounts={[transaction?.senderAccount]}
      fromAccountBalances={fromAccountBalances}
      recipientAccounts={[transaction?.recipientAccount]}
      toAccountBalances={toAccountBalances}
    />
  );
};

export default ProblemExchangeGeneralContentHOC;
